import { useEffect, useState } from "react";
import { useWindowSize } from "react-use";
import { useAppConfigSelector } from "@redux/reducers/appConfig";

export const useIsStickyTopOrBottom = (
  isStickyToTop,
  isStickyToBottom,
  topThresholdRef,
  bottomThresholdRef,
  topOffset,
  bottomOffset = 0
) => {
  const appConfig = useAppConfigSelector();
  if (
    !appConfig.configuration.ui?.orderRequestSticky ||
    (!isStickyToTop && !isStickyToBottom)
  ) {
    return {
      stickToTop: false,
      stickToBottom: false,
    };
  }

  const { height: windowHeight } = useWindowSize();
  const [stickToTop, setStickToTop] = useState(false);
  // use isStickyToBottom as default state to make button sticky on page load
  const [stickToBottom, setStickToBottom] = useState(isStickyToBottom);

  useEffect(() => {
    const handleScroll = () => {
      if (!topThresholdRef.current || !bottomThresholdRef.current) {
        return;
      }
      const topThreshold = topThresholdRef.current.getBoundingClientRect();
      const bottomThreshold = bottomThresholdRef.current.getBoundingClientRect();

      if (isStickyToTop) {
        setStickToTop(topThreshold.y < topOffset);
      }

      if (isStickyToBottom) {
        setStickToBottom(bottomThreshold.y - bottomOffset > windowHeight);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, [topOffset, bottomOffset, windowHeight]);

  return { stickToTop, stickToBottom };
};
